module.exports = "./assets/assets/公开开招标(服务).89681f94.docx";